var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-section container px-3"},[_c('h2',{staticClass:"content-section-title"},[_vm._v(_vm._s(_vm.title))]),_c('b-row',{staticClass:"justify-content-start"},_vm._l((_vm.infos),function(info,index){return _c('div',{key:index,staticClass:"an-wrap"},[_c('An',{attrs:{"info":info,"desc":true}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }